/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_B3Inputs */

const en_mk_agent_3_b3 = /** @type {(inputs: Mk_Agent_3_B3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents never reply to agents — no runaway conversations`)
};

const id_mk_agent_3_b3 = /** @type {(inputs: Mk_Agent_3_B3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen tidak pernah membalas agen — tidak ada obrolan tak berujung`)
};

/**
* | output |
* | --- |
* | "Agents never reply to agents — no runaway conversations" |
*
* @param {Mk_Agent_3_B3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_b3 = /** @type {((inputs?: Mk_Agent_3_B3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_B3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_b3(inputs)
	return en_mk_agent_3_b3(inputs)
});